import Vue from "vue"
import VueMeta from "vue-meta"
import VueGtag from "vue-gtag"
import VuePortal from "@linusborg/vue-simple-portal"

import router from "@/router"
import store from "@/store"

import "@/plugins"

import "@/registerServiceWorker"
import "@/assets/styles/application.scss"

import fetchGlobalState from "@/lib/fetch-global-state"
import pwaTheme from "@/lib/pwa-theme"
import { addExternalLinks } from "@/lib/add-external-links"
import { VARIABLES } from "@/lib/globals"
import { setupStripe } from "@/lib/mixins/use-stripe"

import App from "@/App"

Vue.config.productionTip = false

Vue.use(VueMeta, { keyName: "head" })

Vue.use(VuePortal)

if (["production", "staging"].includes(process.env.VUE_APP_ENV)) {
  Vue.use(VueGtag, { bootstrap: false }, router)
}

Vue.config.errorHandler = err => {
  if (process.env.NODE_ENV !== "production") {
    console.error(err)
  }
}

fetchGlobalState().then(state => {
  store.commit("setGlobalState", state)
  window[VARIABLES.GLOBAL_STATE] = state
  pwaTheme(state.theme)
  if (state.external) addExternalLinks(state.external.links)

  // Should make available everywhere
  // https://github.com/stripe/stripe-js#ensuring-stripejs-is-available-everywhere
  if (state.payments.stripe_account_id) {
    setupStripe(state.payments.stripe_account_id)
  }

  // Sometimes /__/global.js can be cached by the browser
  // so, if require_sign_in changes, it may still allow browsing, or visa-versa
  setTimeout(() => {
    if (
      store.getters["access/requiresAuthentication"] &&
      !store.getters["access/allowsAnonymousBrowsing"] &&
      !store.getters["auth/isAuthenticated"]
    ) {
      router.push() // Trigger beforeEach $router hook
    }
  }, 500)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
